var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_6274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2476 0H1.60982C1.29657 0 0.996152 0.124438 0.774651 0.34594C0.553149 0.567441 0.428711 0.867861 0.428711 1.18111V14.8189C0.428711 15.1321 0.553149 15.4326 0.774651 15.6541C0.996152 15.8756 1.29657 16 1.60982 16H15.2476C15.5609 16 15.8613 15.8756 16.0828 15.6541C16.3043 15.4326 16.4287 15.1321 16.4287 14.8189V1.18111C16.4287 0.867861 16.3043 0.567441 16.0828 0.34594C15.8613 0.124438 15.5609 0 15.2476 0ZM5.1976 13.63H2.79204V5.98889H5.1976V13.63ZM3.99316 4.93C3.72029 4.92846 3.45399 4.84613 3.22787 4.69339C3.00175 4.54065 2.82594 4.32435 2.72263 4.07179C2.61932 3.81923 2.59314 3.54173 2.6474 3.2743C2.70165 3.00688 2.83391 2.76152 3.02748 2.56919C3.22105 2.37686 3.46725 2.24618 3.73502 2.19364C4.00279 2.1411 4.28012 2.16906 4.53201 2.27399C4.78391 2.37892 4.99907 2.55611 5.15035 2.78321C5.30164 3.01031 5.38226 3.27713 5.38204 3.55C5.38462 3.73269 5.35039 3.91403 5.28139 4.0832C5.21239 4.25238 5.11003 4.40593 4.98042 4.53471C4.85082 4.66349 4.69661 4.76486 4.52699 4.83277C4.35738 4.90068 4.17582 4.93375 3.99316 4.93ZM14.0643 13.6367H11.6598V9.46222C11.6598 8.23111 11.1365 7.85111 10.4609 7.85111C9.7476 7.85111 9.0476 8.38889 9.0476 9.49333V13.6367H6.64204V5.99445H8.95538V7.05333H8.98649C9.21871 6.58333 10.032 5.78 11.2732 5.78C12.6154 5.78 14.0654 6.57667 14.0654 8.91L14.0643 13.6367Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_6274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.428711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinColor);
export default __webpack_public_path__ + "static/media/Linkedin-color.cab62e20ea2d56911e209dbeda7e9179.svg";
export { ForwardRef as ReactComponent };